// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Legacy redirect route for /items/{itemKey}/pricing.
 * Redirects to /catalog/items/{itemKey}/pricing.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/items/$itemKey/pricing')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/catalog/items/$itemKey/pricing',
      params: { itemKey: params.itemKey },
      search: true,
    });
  },
});
